// LORYÉ theme JS
(function(){
  var header=document.querySelector('.site-header');
  if(header && header.classList.contains('on-dark')){
    addEventListener('scroll',function(){header.classList.toggle('scrolled',scrollY>60)},{passive:true});
  }
  var toggle=document.querySelector('.menu-toggle');
  if(toggle){toggle.addEventListener('click',function(){document.querySelector('.header-nav').classList.toggle('open')});}
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target)}})},{threshold:.15});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
  } else {document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('visible')});}

  // Product gallery
  var main=document.getElementById('gallery-main-img');
  document.querySelectorAll('.gallery-thumbs button').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(main){main.src=btn.dataset.src;}
      document.querySelectorAll('.gallery-thumbs button').forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
    });
  });

  // ----- Variant matching: swatches + pills -> variant id, price, availability -----
  var vJson=document.getElementById('product-variants-json');
  if(vJson){
    var variants=[];
    try{variants=JSON.parse(vJson.textContent)}catch(e){}
    var idInput=document.getElementById('variant-id'),
        priceEl=document.getElementById('product-price'),
        atc=document.getElementById('atc-btn'),
        groups=document.querySelectorAll('.opt-group'),
        stickyPrice=document.querySelector('.sticky-atc .sa-price');

    function money(cents){
      var el=document.createElement('span');
      // Use the same currency formatting Shopify rendered server-side by
      // borrowing symbol position from the current price text.
      var current=(priceEl&&priceEl.textContent)||'';
      var sym=current.replace(/[\d.,\s]/g,'')||'$';
      return sym+(cents/100).toFixed(2);
    }

    function selectedOptions(){
      var out=[];
      groups.forEach(function(g,i){
        var c=g.querySelector('input:checked');
        out[i]=c?c.value:null;
      });
      return out;
    }

    function update(){
      var sel=selectedOptions();
      var match=variants.find(function(v){
        return sel.every(function(val,i){return val===null||v.options[i]===val});
      });
      if(!match){
        if(atc){atc.disabled=true;atc.textContent=atc.dataset.labelSold;}
        return;
      }
      if(idInput){idInput.value=match.id;}
      if(priceEl){priceEl.innerHTML=money(match.price);}
      if(stickyPrice){stickyPrice.textContent=money(match.price);}
      if(atc){
        atc.disabled=!match.available;
        atc.textContent=match.available?atc.dataset.labelAdd:atc.dataset.labelSold;
      }
      // Update the selected-colour name label
      groups.forEach(function(g,i){
        var lbl=g.querySelector('.opt-selected');
        var c=g.querySelector('input:checked');
        if(lbl&&c){lbl.textContent=c.value;}
      });
      // Swap main image if the variant has its own image
      if(match.featured_image&&match.featured_image.src&&main){
        main.src=match.featured_image.src;
      }
    }

    groups.forEach(function(g){
      g.querySelectorAll('input[type="radio"]').forEach(function(r){
        r.addEventListener('change',update);
      });
    });
    if(groups.length){update();}
  }

  // Sticky mobile add-to-cart
  var sticky=document.querySelector('.sticky-atc'),form=document.querySelector('.product-form');
  if(sticky&&form&&'IntersectionObserver' in window){
    var io2=new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('visible',!e.isIntersecting)})},{threshold:0});
    io2.observe(form);
    var sBtn=document.getElementById('sticky-atc-btn');
    if(sBtn){sBtn.addEventListener('click',function(){form.querySelector('[type="submit"]').click()});}
  }
})();
